import { categories } from '@/mocks/categories';

interface CategoryGridProps {
  onCategoryClick: (url: string) => void;
}

export default function CategoryGrid({ onCategoryClick }: CategoryGridProps) {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Select a category to explore curated finds and product spreadsheets on Kakobuy Sheet
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryClick(cat.url)}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-500 transition-all duration-300">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}